module.exports = __webpack_public_path__ + "static/alec-bernasconi-eb3cb56ab6b5e1d7a2205a0b0f3d138a.jpg";